module.exports = __webpack_public_path__ + "img/FR30958.1fd52cb7.png";